import React from 'react';
import { PracticeButton } from './PflegePracticeButton';

/* Tab B1 – Begrüßung & Vorstellung */
export const TabBegruessung = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Begrüßung & Vorstellung</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>Greetings & Introductions · <span className="ar">التحيات والتعريف بالنفس</span></p>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🤝</span>
        <h3>Begrüßungen · Greetings · <span className="ar">التحيات</span></h3>
      </div>
      <div className="pflege-card-body">
        <div className="phrase-grid">
          {[
            { ctx: 'Morgens', de: 'Guten Morgen!', en: 'Good morning!', ar: 'صباح الخير!' },
            { ctx: 'Mittags', de: 'Guten Tag!', en: 'Good day!', ar: 'نهارك سعيد!' },
            { ctx: 'Abends', de: 'Guten Abend!', en: 'Good evening!', ar: 'مساء الخير!' },
            { ctx: 'Immer', de: 'Hallo!', en: 'Hello!', ar: 'مرحباً!' },
            { ctx: 'Abschied', de: 'Auf Wiedersehen!', en: 'Goodbye!', ar: 'مع السلامة!' },
            { ctx: 'Informal', de: 'Tschüss!', en: 'Bye!', ar: 'باي!' },
            { ctx: 'Nacht', de: 'Gute Nacht!', en: 'Good night!', ar: 'تصبح على خير!' },
            { ctx: 'Frage', de: 'Wie geht es Ihnen?', en: 'How are you? (formal)', ar: 'كيف حالك؟' },
            { ctx: 'Antwort', de: 'Danke, gut. / Nicht so gut.', en: 'Good, thanks. / Not so good.', ar: 'شكراً، بخير. / ليس جيداً.' },
            { ctx: 'Höflichkeit', de: 'Bitte / Danke / Entschuldigung', en: 'Please / Thank you / Sorry', ar: 'من فضلك / شكراً / آسف' },
          ].map((item, i) => (
            <div key={`greet-${item.ctx}-${i}`} className="phrase-card">
              <div className="phrase-ctx">{item.ctx}</div>
              <div className="phrase-de flex items-center justify-between">
                <span>{item.de}</span>
                <PracticeButton text={item.de} />
              </div>
              <div className="phrase-en">{item.en}</div>
              <div className="phrase-ar">{item.ar}</div>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🪪</span>
        <h3>Vorstellung · Introductions · <span className="ar">التعريف بالنفس</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
          <tbody>
            {[
              { de: 'Ich heiße Maria.', en: 'My name is Maria.', ar: 'اسمي ماريا.' },
              { de: 'Ich bin Pflegerin.', en: 'I am a nurse.', ar: 'أنا ممرضة.' },
              { de: 'Ich komme aus Syrien.', en: 'I come from Syria.', ar: 'أنا من سوريا.' },
              { de: 'Ich arbeite hier.', en: 'I work here.', ar: 'أنا أعمل هنا.' },
              { de: 'Ich helfe Ihnen.', en: 'I will help you.', ar: 'سأساعدك.' },
              { de: 'Einen Moment bitte.', en: 'One moment please.', ar: 'لحظة من فضلك.' },
            ].map((item, i) => (
              <tr key={`intro-${item.de.slice(0,8)}-${i}`}>
                <td className="de">{item.de}</td>
                <td className="en">{item.en}</td>
                <td className="ar">{item.ar}</td>
                <td><PracticeButton text={item.de} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="tip-box">
          <strong>Tipp · Tip · <span className="ar">نصيحة</span></strong><br/>
          Sagen Sie immer <em>„Sie"</em> (formal) zu Patienten — nie „du". · Always use <em>"Sie"</em> with patients, never "du". · <span className="ar">استخدم دائماً «Sie» الرسمية مع المرضى.</span>
        </div>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">👥</span>
        <h3>Berufe · Jobs · <span className="ar">المهن</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
          <tbody>
            {[
              { de: 'der Pfleger', en: 'Nurse (m)', ar: 'ممرض' },
              { de: 'die Pflegerin', en: 'Nurse (f)', ar: 'ممرضة' },
              { de: 'der Arzt', en: 'Doctor (m)', ar: 'طبيب' },
              { de: 'die Ärztin', en: 'Doctor (f)', ar: 'طبيبة' },
              { de: 'der Patient', en: 'Patient (m)', ar: 'مريض' },
              { de: 'die Patientin', en: 'Patient (f)', ar: 'مريضة' },
            ].map((item, i) => (
              <tr key={`job-${item.de.slice(0,8)}-${i}`}>
                <td className="de">{item.de}</td>
                <td className="en">{item.en}</td>
                <td className="ar">{item.ar}</td>
                <td><PracticeButton text={item.de} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

/* Tab B2 – Körper & Schmerz */
export const TabKoerper = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Körper & Schmerz</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>Body & Pain · <span className="ar">الجسم والألم</span></p>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🫁</span>
        <h3>Körperteile · Body Parts · <span className="ar">أجزاء الجسم</span></h3>
      </div>
      <div className="pflege-card-body">
        <div className="body-grid">
          {[
            { art: 'der', de: 'Kopf', en: 'head', ar: 'رأس' },
            { art: 'das', de: 'Gesicht', en: 'face', ar: 'وجه' },
            { art: 'der', de: 'Hals', en: 'neck / throat', ar: 'رقبة / حلق' },
            { art: 'die', de: 'Schulter', en: 'shoulder', ar: 'كتف' },
            { art: 'die', de: 'Brust', en: 'chest', ar: 'صدر' },
            { art: 'der', de: 'Bauch', en: 'abdomen', ar: 'بطن' },
            { art: 'der', de: 'Rücken', en: 'back', ar: 'ظهر' },
            { art: 'der', de: 'Arm', en: 'arm', ar: 'ذراع' },
            { art: 'die', de: 'Hand', en: 'hand', ar: 'يد' },
            { art: 'der', de: 'Finger', en: 'finger', ar: 'إصبع' },
            { art: 'das', de: 'Bein', en: 'leg', ar: 'ساق' },
            { art: 'der', de: 'Fuß', en: 'foot', ar: 'قدم' },
            { art: 'das', de: 'Knie', en: 'knee', ar: 'ركبة' },
            { art: 'die', de: 'Hüfte', en: 'hip', ar: 'ورك' },
            { art: 'das', de: 'Auge', en: 'eye', ar: 'عين' },
            { art: 'das', de: 'Ohr', en: 'ear', ar: 'أذن' },
            { art: 'der', de: 'Mund', en: 'mouth', ar: 'فم' },
            { art: 'die', de: 'Nase', en: 'nose', ar: 'أنف' },
            { art: 'das', de: 'Herz', en: 'heart', ar: 'قلب' },
            { art: 'die', de: 'Lunge', en: 'lung', ar: 'رئة' },
          ].map((item, i) => (
            <div key={`body-${item.de}-${i}`} className="body-item">
              <div className="de"><span className="art">{item.art}</span> {item.de}</div>
              <div className="en">{item.en}</div>
              <div className="ar">{item.ar}</div>
              <div className="mt-1"><PracticeButton text={`${item.art} ${item.de}`} /></div>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">😖</span>
        <h3>Schmerzen · Pain · <span className="ar">الألم</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
          <tbody>
            {[
              { de: 'Ich habe Schmerzen.', en: 'I am in pain.', ar: 'أنا أتألم.' },
              { de: 'Es tut weh.', en: 'It hurts.', ar: 'يؤلمني.' },
              { de: 'Wo tut es Ihnen weh?', en: 'Where does it hurt?', ar: 'أين يؤلمك؟' },
              { de: 'Kopfschmerzen', en: 'Headache', ar: 'صداع' },
              { de: 'Bauchschmerzen', en: 'Stomach ache', ar: 'ألم في البطن' },
              { de: 'Rückenschmerzen', en: 'Back pain', ar: 'ألم في الظهر' },
            ].map((item, i) => (
              <tr key={`pain-${item.de.slice(0,8)}-${i}`}>
                <td className="de">{item.de}</td>
                <td className="en">{item.en}</td>
                <td className="ar">{item.ar}</td>
                <td><PracticeButton text={item.de} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="tip-box">
          <strong>Schmerzskala · Pain Scale · <span className="ar">مقياس الألم</span></strong><br/>
          „Wie stark sind die Schmerzen? Von 0 bis 10?" · "How strong is the pain? 0 to 10?" · <span className="ar">ما شدة الألم؟ من 0 إلى 10؟</span><br/>
          0 = kein Schmerz / no pain / <span className="ar">لا ألم</span> | 5 = mittel / moderate / <span className="ar">متوسط</span> | 10 = sehr stark / very strong / <span className="ar">شديد جداً</span>
        </div>
        <div style={{marginTop: '16px'}}>
          <div style={{fontWeight: '600', fontSize: '12px', color: '#94a3b8', marginBottom: '8px'}}>Zustände · Conditions · <span className="ar">الأحوال</span></div>
          <div className="chips">
            <span className="chip">müde · tired · <span className="ar">متعب</span></span>
            <span className="chip">schwindelig · dizzy · <span className="ar">دوار</span></span>
            <span className="chip">schwach · weak · <span className="ar">ضعيف</span></span>
            <span className="chip">kalt · cold · <span className="ar">بارد</span></span>
            <span className="chip">hungrig · hungry · <span className="ar">جائع</span></span>
            <span className="chip">durstig · thirsty · <span className="ar">عطشان</span></span>
            <span className="chip">ängstlich · anxious · <span className="ar">قلق</span></span>
            <span className="chip green">Übelkeit · nausea · <span className="ar">غثيان</span></span>
            <span className="chip green">Fieber · fever · <span className="ar">حمى</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* Tab B3 – Pflegealltag */
export const TabAlltag = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Pflegealltag</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>Daily Care · <span className="ar">الروتين اليومي في التمريض</span></p>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🛏️</span>
        <h3>Ausrüstung · Equipment · <span className="ar">المعدات</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
          <tbody>
            {[
              { art: 'das', de: 'Bett', en: 'bed', ar: 'سرير' },
              { art: 'die', de: 'Klingel', en: 'call bell', ar: 'جرس النداء' },
              { art: 'der', de: 'Rollstuhl', en: 'wheelchair', ar: 'كرسي متحرك' },
              { art: 'die', de: 'Tablette', en: 'pill / tablet', ar: 'حبة دواء' },
              { art: 'die', de: 'Spritze', en: 'injection / syringe', ar: 'حقنة' },
              { art: 'der', de: 'Verband', en: 'bandage / dressing', ar: 'ضمادة' },
              { art: 'das', de: 'Thermometer', en: 'thermometer', ar: 'ميزان الحرارة' },
              { art: 'der', de: 'Blutdruck', en: 'blood pressure', ar: 'ضغط الدم' },
              { art: 'die', de: 'Wunde', en: 'wound', ar: 'جرح' },
              { art: 'das', de: 'Medikament', en: 'medication', ar: 'دواء' },
              { art: 'die', de: 'Infusion', en: 'infusion / drip', ar: 'مصل / إنفيوجن' },
            ].map((item, i) => (
              <tr key={`equip-${item.de}-${i}`}>
                <td><span className="art">{item.art}</span><span className="de">{item.de}</span></td>
                <td className="en">{item.en}</td>
                <td className="ar">{item.ar}</td>
                <td><PracticeButton text={`${item.art} ${item.de}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🗣️</span>
        <h3>Pflegesätze · Care Phrases · <span className="ar">جمل التمريض</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
          <tbody>
            {[
              { de: 'Bitte aufmachen!', en: 'Please open (mouth)!', ar: 'افتح فمك من فضلك!' },
              { de: 'Bitte tief einatmen.', en: 'Please breathe in deeply.', ar: 'تنفس بعمق من فضلك.' },
              { de: 'Bitte ausatmen.', en: 'Please breathe out.', ar: 'ازفر من فضلك.' },
              { de: 'Drehen Sie sich bitte.', en: 'Please turn over.', ar: 'تقلب من فضلك.' },
              { de: 'Haben Sie gut geschlafen?', en: 'Did you sleep well?', ar: 'هل نمت جيداً؟' },
              { de: 'Ich messe Ihren Blutdruck.', en: "I'll measure your blood pressure.", ar: 'سأقيس ضغط دمك.' },
              { de: 'Ich nehme Ihre Temperatur.', en: "I'll take your temperature.", ar: 'سأقيس درجة حرارتك.' },
              { de: 'Ich rufe den Arzt.', en: 'I will call the doctor.', ar: 'سأستدعي الطبيب.' },
              { de: 'Alles wird gut.', en: 'Everything will be okay.', ar: 'كل شيء سيكون بخير.' },
              { de: 'Bleiben Sie ruhig.', en: 'Stay calm.', ar: 'ابق هادئاً.' },
              { de: 'Ich bin bei Ihnen!', en: 'I am with you!', ar: 'أنا معك!' },
            ].map((item, i) => (
              <tr key={`care-${item.de.slice(0,8)}-${i}`}>
                <td className="de">{item.de}</td>
                <td className="en">{item.en}</td>
                <td className="ar">{item.ar}</td>
                <td><PracticeButton text={item.de} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

/* Tab B4 – Zahlen & Zeit */
export const TabZahlen = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Zahlen & Zeit</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>Numbers & Time · <span className="ar">الأرقام والوقت</span></p>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🔢</span>
        <h3>Zahlen · Numbers · <span className="ar">الأرقام</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>#</th><th>Deutsch</th><th>English</th><th className="ar">عربي</th></tr></thead>
          <tbody>
            {[
              [0, 'null', 'zero', 'صفر'], [1, 'eins', 'one', 'واحد'], [2, 'zwei', 'two', 'اثنان'],
              [3, 'drei', 'three', 'ثلاثة'], [4, 'vier', 'four', 'أربعة'], [5, 'fünf', 'five', 'خمسة'],
              [6, 'sechs', 'six', 'ستة'], [7, 'sieben', 'seven', 'سبعة'], [8, 'acht', 'eight', 'ثمانية'],
              [9, 'neun', 'nine', 'تسعة'], [10, 'zehn', 'ten', 'عشرة'], [11, 'elf', 'eleven', 'أحد عشر'],
              [12, 'zwölf', 'twelve', 'اثنا عشر'], [20, 'zwanzig', 'twenty', 'عشرون'],
              [30, 'dreißig', 'thirty', 'ثلاثون'], [50, 'fünfzig', 'fifty', 'خمسون'],
              [100, 'hundert', 'hundred', 'مئة']
            ].map((row, i) => (
              <tr key={`num-${row[0]}`}><td>{row[0]}</td><td className="de">{row[1]}</td><td className="en">{row[2]}</td><td className="ar">{row[3]}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🕐</span>
        <h3>Uhrzeit · Telling Time · <span className="ar">الوقت</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Zeit</th><th>Deutsch</th><th>English</th><th className="ar">عربي</th></tr></thead>
          <tbody>
            <tr><td>08:00</td><td className="de">Es ist acht Uhr.</td><td className="en">It is 8 o'clock.</td><td className="ar">الساعة الثامنة.</td></tr>
            <tr><td>08:15</td><td className="de">Viertel nach acht.</td><td className="en">Quarter past eight.</td><td className="ar">الثامنة والربع.</td></tr>
            <tr><td>08:30</td><td className="de">Halb neun.*</td><td className="en">Half past eight.*</td><td className="ar">الثامنة والنصف.</td></tr>
            <tr><td>08:45</td><td className="de">Viertel vor neun.</td><td className="en">Quarter to nine.</td><td className="ar">التاسعة إلا ربع.</td></tr>
            <tr><td>12:00</td><td className="de">Mittag.</td><td className="en">Noon.</td><td className="ar">الظهر.</td></tr>
            <tr><td>00:00</td><td className="de">Mitternacht.</td><td className="en">Midnight.</td><td className="ar">منتصف الليل.</td></tr>
          </tbody>
        </table>
        <div className="tip-box">
          <strong>Achtung! · <span className="ar">انتبه!</span></strong><br/>
          „Halb neun" = Englisch: half past EIGHT — nicht nine! · <span className="ar">«نصف التاسعة» تعني 8:30 وليس 9:30!</span>
        </div>
        <div style={{marginTop: '16px'}}>
          <div style={{fontWeight: '600', fontSize: '12px', color: '#94a3b8', marginBottom: '8px'}}>Zeitwörter · Time Words · <span className="ar">كلمات الوقت</span></div>
          <div className="chips">
            <span className="chip">heute · today · <span className="ar">اليوم</span></span>
            <span className="chip">morgen · tomorrow · <span className="ar">غداً</span></span>
            <span className="chip">gestern · yesterday · <span className="ar">أمس</span></span>
            <span className="chip">jetzt · now · <span className="ar">الآن</span></span>
            <span className="chip">gleich · soon · <span className="ar">قريباً</span></span>
            <span className="chip">morgens · in the morning · <span className="ar">صباحاً</span></span>
            <span className="chip">abends · in the evening · <span className="ar">مساءً</span></span>
            <span className="chip green">täglich · daily · <span className="ar">يومياً</span></span>
            <span className="chip green">dreimal täglich · 3x/day · <span className="ar">ثلاث مرات يومياً</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
);
